export const iconsData = [
  {
    name: "user",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M304 128a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm-208 0a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM49 464h350c-9-63-64-112-129-112h-92c-65 0-120 49-129 112zM0 482c0-98 80-178 178-178h92c98 0 178 80 178 178 0 17-13 30-30 30H30c-17 0-30-13-30-30z" />
      </svg>
    ),
  },

  {
    name: "eye",
    icon: (
      <svg viewBox="0 0 576 512">
        <path d="M288 80c-65 0-119 30-160 68-38 36-65 78-79 108 14 30 41 73 79 108 41 38 95 68 160 68s119-30 160-68c38-35 65-78 79-108-14-30-41-72-79-108-41-38-95-68-160-68zM95 113c48-44 112-81 193-81s146 37 193 81c46 43 78 95 93 131 3 8 3 16 0 24-15 36-47 88-93 131-47 44-112 81-193 81s-145-37-193-81c-46-43-78-95-92-131-4-8-4-16 0-24 14-36 46-88 92-131zm193 223a80 80 0 1 0 0-160h-2l2 16a64 64 0 0 1-80 62v2c0 44 36 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" />
      </svg>
    ),
  },

  {
    name: "eyeSlash",
    icon: (
      <svg viewBox="0 0 640 512">
        <path d="M39 5A24 24 0 0 0 9 43l592 464a24 24 0 0 0 30-38l-105-82c39-41 66-86 80-119 3-8 3-16 0-24-15-36-47-88-93-131-47-44-112-81-193-81-68 0-125 26-169 61L39 5zm151 118c36-25 80-43 130-43 65 0 119 30 160 68 38 36 65 78 79 108-13 28-37 67-71 101l-54-42a128 128 0 0 0-198-155l-46-37zm205 161-82-64a64 64 0 0 0 5-44h2a80 80 0 0 1 75 108zm51 164-42-33c-25 10-53 17-84 17-65 0-119-30-160-68-38-35-65-78-79-108 9-18 22-41 40-65l-38-29c-23 29-39 59-48 82-4 8-4 16 0 24 14 36 46 88 93 131a263 263 0 0 0 319 48zm-88-70-56-44c-23-5-43-21-54-42l-56-45v9a128 128 0 0 0 166 122z" />
      </svg>
    ),
  },

  {
    name: "burgerMenu",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
      </svg>
    ),
  },

  {
    name: "chevronRight",
    icon: (
      <svg viewBox="0 0 320 512">
        <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
      </svg>
    ),
  },

  {
    name: "search",
    icon: (
      <svg viewBox="0 0 512 512">
        <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
      </svg>
    ),
  },

  {
    name: "xMark",
    icon: (
      <svg viewBox="0 0 384 512">
        <path d="M343 151a32 32 0 0 0-46-46L192 211 87 105a32 32 0 0 0-46 46l106 105L41 361a32 32 0 0 0 46 46l105-106 105 106a32 32 0 0 0 46-46L237 256l106-105z" />
      </svg>
    ),
  },

  {
    name: "email2",
    icon: (
      <svg fill="none" viewBox="0 0 22 16">
        <path stroke="#fff" d="m1 1 10 7 10-7M1 15h20V1H1v14Z" />
      </svg>
    ),
  },

  {
    name: "phone",
    icon: (
      <svg fill="none" viewBox="0 0 22 22">
        <path
          stroke="#fff"
          d="M9.554 5.24 6.171 1.335c-.39-.45-1.105-.448-1.558.006L1.831 4.128c-.828.829-1.065 2.06-.586 3.047a29.207 29.207 0 0 0 13.561 13.58c.986.479 2.216.242 3.044-.587l2.808-2.813c.455-.455.456-1.174.002-1.564l-3.92-3.365c-.41-.352-1.047-.306-1.458.106l-1.364 1.366a.462.462 0 0 1-.553.088 14.558 14.558 0 0 1-5.36-5.367.463.463 0 0 1 .088-.554l1.36-1.361c.412-.414.457-1.054.101-1.465v.001Z"
        />
      </svg>
    ),
  },

  {
    name: "checked",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M439 105c12 13 12 33 0 46L183 407a32 32 0 0 1-46 0L9 279a32 32 0 0 1 46-46l105 106 233-234c13-12 33-12 46 0z" />
      </svg>
    ),
  },

  {
    name: "star",
    icon: (
      <svg viewBox="0 0 576 512">
        <path d="M288 0c9 0 17 5 21 14l69 141 153 22c9 2 17 8 20 17s0 18-6 24L434 328l26 156a24 24 0 0 1-35 25l-137-73-137 73c-8 4-18 4-25-2s-11-14-10-23l26-156L31 218a24 24 0 0 1 14-41l153-22 68-141c4-9 13-14 22-14zm0 79-53 108c-3 7-10 12-18 13L99 219l86 85c5 6 8 13 7 21l-21 120 106-57c7-3 15-3 22 1l105 56-20-120c-1-8 1-15 7-21l86-85-118-17c-8-2-15-7-18-14L288 79z" />
      </svg>
    ),
  },

  {
    name: "list",
    icon: (
      <svg viewBox="0 0 512 512">
        <path d="M40 48c-13 0-24 11-24 24v48c0 13 11 24 24 24h48c13 0 24-11 24-24V72c0-13-11-24-24-24H40zm152 16a32 32 0 1 0 0 64h288a32 32 0 1 0 0-64H192zm0 160a32 32 0 1 0 0 64h288a32 32 0 1 0 0-64H192zm0 160a32 32 0 1 0 0 64h288a32 32 0 1 0 0-64H192zM16 232v48c0 13 11 24 24 24h48c13 0 24-11 24-24v-48c0-13-11-24-24-24H40c-13 0-24 11-24 24zm24 136c-13 0-24 11-24 24v48c0 13 11 24 24 24h48c13 0 24-11 24-24v-48c0-13-11-24-24-24H40z" />
      </svg>
    ),
  },

  {
    name: "home",
    icon: (
      <svg viewBox="0 0 16 16">
        <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z" />
      </svg>
    ),
  },

  {
    name: "filePaper",
    icon: (
      <svg viewBox="0 0 384 512">
        <path d="M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z" />
      </svg>
    ),
  },

  {
    name: "bag",
    icon: (
      <svg viewBox="0 0 16 16">
        <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z" />
      </svg>
    ),
  },

  {
    name: "bell",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112v25.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V208c0-61.9 50.1-112 112-112zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z" />
      </svg>
    ),
  },

  {
    name: "boxArrowRight",
    icon: (
      <svg fill="currentColor" viewBox="0 0 16 16">
        <path
          fillRule="evenodd"
          d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
        />
        <path
          fillRule="evenodd"
          d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
        />
      </svg>
    ),
  },

  {
    name: "arrowRightLong",
    icon: (
      <svg viewBox="0 0 512 512">
        <path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l73.4 73.4H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h370.7l-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z" />
      </svg>
    ),
  },

  {
    name: "cart3",
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16">
        <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l.84 4.479 9.144-.459L13.89 4zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
      </svg>
    ),
  },

  {
    name: "gamepad",
    icon: (
      <svg strokeWidth="2" viewBox="0 0 56 56" data-stroke-hover>
        <rect
          width="46"
          height="28"
          x="5"
          y="14"
          fill="none"
          stroke="#000"
          rx="5"
          ry="5"
        />
        <path d="M14 28h9m-4-5v10" />
        <circle cx="36" cy="25" r="1.5" />
        <circle cx="43" cy="30" r="1.5" />
      </svg>
    ),
  },

  {
    name: "headphone",
    icon: (
      <svg fill="none" viewBox="0 0 56 56" strokeWidth="2" data-stroke-hover>
        <g stroke="#000">
          <path d="M16 30h-2c-3 0-5 2-5 5v7c0 3 2 5 5 5h2c3 0 5-2 5-5v-7c0-3-2-5-5-5Zm26 0h-2c-3 0-5 2-5 5v7c0 3 2 5 5 5h2c3 0 5-2 5-5v-7c0-3-2-5-5-5Z" />
          <path d="M9 35v-7a19 19 0 0 1 38 0v7" />
        </g>
      </svg>
    ),
  },

  {
    name: "smartWatch",
    icon: (
      <svg fill="none" strokeWidth="2" viewBox="0 0 56 56" data-stroke-hover>
        <path d="M35 14H21c-4 0-7 3-7 7v14c0 4 3 7 7 7h14c4 0 7-3 7-7V21c0-4-3-7-7-7ZM21 42v7h14v-7M21 14V7h14v7m-11 9v11m4-6v6m4-8v8" />
      </svg>
    ),
  },

  {
    name: "computer",
    icon: (
      <svg fill="none" strokeWidth="2" viewBox="0 0 56 56" data-stroke-hover>
        <path
          stroke="#000"
          d="M47 9H9c-1 0-2 1-2 3v23l2 2h38l2-2V12c0-2-1-3-2-3ZM16 47h24M21 37v10m14-10v10M8 32h40"
        />
      </svg>
    ),
  },

  {
    name: "camera",
    icon: (
      <svg fill="none" viewBox="0 0 56 56" strokeWidth="2" data-stroke-hover>
        <g stroke="#000">
          <path d="M12 16h2a5 5 0 0 0 5-4 2 2 0 0 1 2-3h14a2 2 0 0 1 2 3 5 5 0 0 0 5 4h2a5 5 0 0 1 5 5v21a5 5 0 0 1-5 5H12a5 5 0 0 1-5-5V21a5 5 0 0 1 5-5" />
          <path d="M28 37a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z" />
        </g>
      </svg>
    ),
  },

  {
    name: "vector",
    icon: (
      <svg viewBox="0 0 22 20">
        <path
          d="M8.91199 9.9998H2.99999L1.02299 2.1348C1.01033 2.0891 1.00262 2.04216 0.999989 1.9948C0.977989 1.2738 1.77199 0.773804 2.45999 1.1038L21 9.9998L2.45999 18.8958C1.77999 19.2228 0.995989 18.7368 0.999989 18.0288C1.00201 17.9655 1.01313 17.9029 1.03299 17.8428L2.49999 12.9998"
          stroke="#fff"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
  },

  {
    name: "facebook",
    icon: (
      <svg width="11" height="18" viewBox="0 0 11 18" fill="#fff">
        <path d="M6 7H10.5L10 9H6V18H4V9H0V7H4V5.128C4 3.345 4.186 2.698 4.534 2.046C4.87501 1.40181 5.40181 0.875009 6.046 0.534C6.698 0.186 7.345 0 9.128 0C9.65 0 10.108 0.0500001 10.5 0.15V2H9.128C7.804 2 7.401 2.078 6.99 2.298C6.686 2.46 6.46 2.686 6.298 2.99C6.078 3.401 6 3.804 6 5.128V7Z" />
      </svg>
    ),
  },

  {
    name: "twitter",
    icon: (
      <svg width="20" height="20" fill="#fff" viewBox="0 0 512 512">
        <g>
          <path d="M490.7,64.8l-12.3-17.4c-18.5,13.1-39.1,23.1-60.8,29.6l6.2,20.4l16.1-14c-23.1-26.5-55.7-40.2-88.3-40.2   c-27.1,0-54.6,9.5-76.7,28.7l0,0c-25.6,22.2-40.2,54.4-40.2,88.2v0l0,1.6l21.3-0.3h-21.3v21.3H256l-0.6-21.3l-5.3,0.1   c-67,0-130-32.6-168.6-87.6c-4.4-6.3-11.9-9.7-19.5-9c-7.7,0.7-14.3,5.5-17.4,12.6c-0.6,1.6-20.6,46.2-20.7,105.1   c0,33.1,6.5,71,27.6,107c21,36,56.4,69.4,110.7,93.4l8.7-19.5l-12-17.7C121,371.4,76.6,385,31.2,385c-3,0-6-0.1-9-0.2   c-9.8-0.4-18.7,6.1-21.4,15.6S2.4,420,11,424.8c53.4,29.7,110.2,43.9,165.1,43.9c77.2,0,150.8-28.4,205-81.5   c54.2-53.1,88.4-130.9,88.3-226.4l0-0.1c0-7.3-0.7-14.5-2.1-21.6l-21,4l15,15.2c24.6-24.3,41.9-54.9,50.1-88.4   c2.1-8.6-1.4-17.7-8.7-22.7c-7.3-5-17-4.9-24.3,0.2L490.7,64.8l-20.7-5c-6.3,25.9-19.7,49.5-38.6,68.2c-5.1,5-7.3,12.2-6,19.2   c0.9,4.5,1.3,9.2,1.3,13.8l0-0.1c-0.1,85.5-29.8,151-75.5,196c-45.8,44.9-108.2,69.3-175.1,69.3c-47.5,0-97.1-12.3-144.4-38.6   l-10.4,18.6l-0.8,21.3c3.6,0.1,7.2,0.2,10.7,0.2c53.9,0,106.7-16.2,151.4-46.5c6.4-4.4,10-11.8,9.3-19.5   c-0.7-7.7-5.5-14.4-12.6-17.6c-47.4-21.2-74.7-48-91.1-75.9c-16.3-28-21.7-57.9-21.8-85.5c0-24.5,4.3-46.8,8.7-62.8   c2.2-8,4.4-14.4,5.9-18.8c0.8-2.2,1.4-3.8,1.9-4.9l0.5-1.1l0.1-0.2l-3-1.3l3,1.3l0,0l-3-1.3l3,1.3L64,86.1L46.5,98.4   c46.7,66.4,122.7,105.8,203.6,105.8c2.1,0,4.3,0,6.4-0.1c11.6-0.3,20.8-9.7,20.8-21.3v-21.3l0-0.3l0-1c0-21.5,9.3-41.9,25.5-56l0,0   C317,91.9,334.2,86,351.5,85.9c20.8,0,41.3,8.6,56.1,25.5c5.5,6.3,14.2,8.8,22.3,6.4C456,110,480.7,98,503,82.2L490.7,64.8l-20.7-5   L490.7,64.8z" />
        </g>
      </svg>
    ),
  },

  {
    name: "instagram",
    icon: (
      <svg viewBox="0 0 20 20" width="20" strokeWidth="1.5">
        <path
          stroke="#fff"
          d="M15 1H5a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4Z"
        />
        <path stroke="#fff" d="M10 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
        <path fill="#fff" d="M16 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
      </svg>
    ),
  },

  {
    name: "linkedin",
    icon: (
      <svg width="24" viewBox="0 0 24 24" fill="#fff">
        <path d="M11.5 9.05C12.417 8.113 13.611 7.5 15 7.5C16.4587 7.5 17.8576 8.07946 18.8891 9.11091C19.9205 10.1424 20.5 11.5413 20.5 13V20.5H18.5V13C18.5 12.0717 18.1313 11.1815 17.4749 10.5251C16.8185 9.86875 15.9283 9.5 15 9.5C14.0717 9.5 13.1815 9.86875 12.5251 10.5251C11.8687 11.1815 11.5 12.0717 11.5 13V20.5H9.5V8H11.5V9.05ZM4.5 6C4.10218 6 3.72064 5.84196 3.43934 5.56066C3.15804 5.27936 3 4.89782 3 4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3C4.89782 3 5.27936 3.15804 5.56066 3.43934C5.84196 3.72064 6 4.10218 6 4.5C6 4.89782 5.84196 5.27936 5.56066 5.56066C5.27936 5.84196 4.89782 6 4.5 6ZM3.5 8H5.5V20.5H3.5V8Z" />
      </svg>
    ),
  },

  {
    name: "cart",
    icon: (
      <svg width="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M3 6.3V20.5C3 20.7652 3.10536 21.0196 3.29289 21.2071C3.48043 21.3946 3.73478 21.5 4 21.5H20C20.2652 21.5 20.5196 21.3946 20.7071 21.2071C20.8946 21.0196 21 20.7652 21 20.5V6.3H3Z"
          stroke="#fff"
          fill="none"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M21 6.3L18.1665 2.5H5.8335L3 6.3M15.7775 9.6C15.7775 11.699 14.0865 13.4 12 13.4C9.9135 13.4 8.222 11.699 8.222 9.6"
          stroke="#fff"
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },

  {
    name: "solidStar",
    icon: (
      <svg width="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M19.8284 9.93621C20.4517 9.93621 20.7176 10.7286 20.2205 11.1046L16.8905 13.6234C16.1688 14.1693 15.8661 15.1087 16.1334 15.9732L17.3864 20.0261C17.5735 20.6312 16.8729 21.1193 16.3701 20.7341L13.3075 18.3879C12.536 17.7969 11.464 17.7969 10.6925 18.3879L7.61357 20.7466C7.11152 21.1312 6.41161 20.645 6.59677 20.0403L7.83243 16.0046C8.09532 15.146 7.79694 14.2145 7.08413 13.6684L3.73432 11.1022C3.24111 10.7244 3.50831 9.93621 4.12961 9.93621H8.12744C9.07024 9.93621 9.90305 9.32198 10.1815 8.42125L11.379 4.5479C11.5678 3.93721 12.4322 3.93722 12.621 4.5479L13.8185 8.42124C14.0969 9.32198 14.9298 9.93621 15.8726 9.93621H19.8284Z"
          stroke="#fff"
          fill="none"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },

  {
    name: "halfStar",
    icon: (
      <svg viewBox="0 0 20 20" width="22">
        <path
          fill="#FFAD33"
          d="M10 2a1 1 0 0 0-1 1L7 6 3 7a1 1 0 0 0-1 2l3 3-1 4a1 1 0 0 0 2 2l4-2V2Z"
        />
        <path
          d="M10 2h1l2 4 4 1h1v1a1 1 0 0 1 0 1l-3 3 1 5-1 1a1 1 0 0 1-1 0l-4-2V2Z"
          opacity=".3"
        />
      </svg>
    ),
  },

  {
    name: "cancel",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g>
          <path
            d="M8 16L12 12M16 8L11.9992 12M11.9992 12L8 8M12 12L16 16"
            stroke="#fff"
            fill="none"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <circle
            cx="12"
            cy="12"
            r="11.25"
            stroke="#fff"
            fill="none"
            strokeWidth="1.5"
          />
        </g>
      </svg>
    ),
  },

  {
    name: "boxArrowLeft",
    icon: (
      <svg width="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M4 12H13.5M6 15L3 12L6 9M11 7V6C11 5.46957 11.2107 4.96086 11.5858 4.58579C11.9609 4.21071 12.4696 4 13 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V18C20 18.5304 19.7893 19.0391 19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20H13C12.4696 20 11.9609 19.7893 11.5858 19.4142C11.2107 19.0391 11 18.5304 11 18V17"
          stroke="#fff"
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },

  {
    name: "heart",
    icon: (
      <svg viewBox="0 0 512 512">
        <path d="m226 468-3-2L48 303C17 275 0 235 0 193v-3a147 147 0 0 1 256-98 130 130 0 0 1 25-22 147 147 0 0 1 231 120v3c0 42-17 82-48 110L289 466l-3 2a45 45 0 0 1-60 0zm13-323-1-1-18-20a98 98 0 0 0-172 66v3c0 28 12 56 33 75l175 163 175-163c21-19 33-47 33-75v-3a99 99 0 0 0-172-66l-18 20-1 1a24 24 0 0 1-34 0z" />
      </svg>
    ),
  },

  {
    name: "trashCan",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M135 18c6-11 17-18 29-18h120c12 0 23 7 29 18l7 14h96a32 32 0 1 1 0 64H32a32 32 0 1 1 0-64h96l7-14zM32 128h384v320c0 35-29 64-64 64H96c-35 0-64-29-64-64V128zm96 64c-9 0-16 7-16 16v224c0 9 7 16 16 16s16-7 16-16V208c0-9-7-16-16-16zm96 0c-9 0-16 7-16 16v224c0 9 7 16 16 16s16-7 16-16V208c0-9-7-16-16-16zm96 0c-9 0-16 7-16 16v224c0 9 7 16 16 16s16-7 16-16V208c0-9-7-16-16-16z" />
      </svg>
    ),
  },

  {
    name: "arrowUp",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" />
      </svg>
    ),
  },

  {
    name: "dollarSign",
    icon: (
      <svg viewBox="0 0 40 40" fill="#000">
        <path
          d="M20.0003 37.2728C29.5397 37.2728 37.273 29.5395 37.273 20C37.273 10.4606 29.5397 2.72729 20.0003 2.72729C10.4608 2.72729 2.72754 10.4606 2.72754 20C2.72754 29.5395 10.4608 37.2728 20.0003 37.2728Z"
          stroke="#fff"
          strokeWidth="2"
        />
        <path
          d="M25.0914 14.547C24.762 13.9758 24.2834 13.505 23.707 13.1848C23.1305 12.8646 22.4777 12.7072 21.8186 12.7294H18.1823C17.2178 12.7294 16.2929 13.1124 15.611 13.7941C14.929 14.4759 14.5459 15.4005 14.5459 16.3647C14.5459 17.3288 14.929 18.2535 15.611 18.9353C16.2929 19.617 17.2178 20 18.1823 20H21.8186C22.783 20 23.708 20.383 24.3899 21.0648C25.0719 21.7465 25.455 22.6712 25.455 23.6354C25.455 24.5995 25.0719 25.5242 24.3899 26.2059C23.708 26.8877 22.783 27.2707 21.8186 27.2707H18.1823C17.5232 27.2929 16.8704 27.1354 16.2939 26.8153C15.7174 26.4951 15.2389 26.0242 14.9095 25.453"
          stroke="#fff"
          strokeWidth="2.75"
          strokeLinecap="round"
        />
        <path
          d="M20 8.18176V12.1212M20 27.8787V31.8181"
          stroke="#fff"
          strokeWidth="2.75"
          strokeLinecap="round"
        />
      </svg>
    ),
  },

  {
    name: "moneyBag",
    icon: (
      <svg fill="none" stroke="#fff" viewBox="0 0 41 40">
        <path d="M21 18v1a3 3 0 0 1 3 2 2 2 0 0 0-3-1v4a3 3 0 1 1 0 7v1h-1v-1a3 3 0 0 1-3-3h-1 1l3 2v-5a3 3 0 1 1 0-6v-1h1Zm-1 2a2 2 0 1 0 0 4v-4Zm1 9v1a2 2 0 1 0 0-5v4Z" />
        <path d="M13 13h15l5 7 2 7-3 6-11 2c-6 0-9-1-11-2-3-2-3-4-4-6l7-14Zm0 0-5 7m5-7-5 7m0 0-2 7 2-7ZM30 6l1 1-3 4v1l5 7c2 3 3 6 2 8 0 3-1 5-3 7l-11 2-12-2c-2-2-3-4-3-7-1-2 0-5 1-8l6-7v-1l-3-4 1-1 10-2 9 2Zm-3 6 3-4V7h-1l-8 2h-7l-1-1h-2l1 1 2 3h13ZM12 6l-1 1h1l2 1h6l6-1V6a21 21 0 0 0-14 0Z" />
      </svg>
    ),
  },

  {
    name: "shoppingBag",
    icon: (
      <svg fill="#fff" viewBox="0 0 40 40">
        <path d="M12 12V8a5 5 0 0 1 8-3 5 5 0 0 1 8 3v4h3a2 2 0 0 1 2 2v17a6 6 0 0 1-5 6H13a7 7 0 0 1-6-7V14a2 2 0 0 1 2-2h3Zm11 22-1-3V14H9v16a4 4 0 0 0 4 4h10Zm-4-22V8a3 3 0 0 0-5 0v4h5Zm3 0h4V8a3 3 0 0 0-5-1l1 1v4Zm2 19a3 3 0 1 0 7 0V14h-7v17Z" />
      </svg>
    ),
  },

  {
    name: "shop",
    icon: (
      <svg fill="none" stroke="#fff" strokeWidth="2" viewBox="0 0 41 40">
        <path d="M35 5h-7l1 8s1 2 4 2l4-1a1 1 0 0 0 0-1l-1-7a1 1 0 0 0-1-1Z" />
        <path d="m28 5 1 8-4 2c-3 0-5-2-5-2V5h8Zm-8 0v8s-1 2-4 2l-4-2 1-8h7Z" />
        <path d="M13 5H6a1 1 0 0 0-1 1l-1 7a1 1 0 0 0 0 1l4 1 4-2 1-8ZM6 15v17a3 3 0 0 0 3 3h23a3 3 0 0 0 4-3V15" />
        <path d="M25 35V25a3 3 0 0 0-3-3h-3a3 3 0 0 0-4 3v10" />
      </svg>
    ),
  },

  {
    name: "truck",
    icon: (
      <svg fill="none" strokeWidth="2" viewBox="0 0 40 40">
        <g stroke="#000">
          <path d="M12 32a3 3 0 1 0 0-7 3 3 0 0 0 0 7Zm16 0a3 3 0 1 0 0-7 3 3 0 0 0 0 7ZM8 28H7l-2-2v-4M3 8h17l2 2v18m-7 0h10m7 0h1l2-2v-8m0 0H22m13 0-4-7-2-1h-7" />
          <path d="M8 28H7l-2-2v-5M3 8h16l2 2v18m-6 0h10m7 0h1l2-2v-8m0 0H21m14 0-5-7-1-1h-8M5 12h7M2 15h6m-3 4h7" />
        </g>
      </svg>
    ),
  },

  {
    name: "infiniteArrows",
    icon: (
      <svg fill="none" stroke="#000" strokeWidth="2" viewBox="0 0 40 40">
        <path
          d="M33 18a13.5 13 0 0 0-26-3m0-7v7h6m-6 7a13 13 0 0 0 25 3m1 7v-7h-6"
          strokeLinecap="round"
        />
      </svg>
    ),
  },

  {
    name: "arrowUp2",
    icon: (
      <svg viewBox="0 0 384 512">
        <path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z" />
      </svg>
    ),
  },

  {
    name: "mobile",
    icon: (
      <svg fill="none" strokeWidth="2" viewBox="0 0 56 56" data-stroke-hover>
        <path
          stroke="#000"
          d="M39 6H17c-1 0-3 1-3 3v38c0 2 2 3 3 3h22c1 0 3-1 3-3V9c0-2-2-3-3-3ZM26 7h5M15 40h26"
        />
      </svg>
    ),
  },

  {
    name: "codeFork",
    icon: (
      <svg viewBox="0 0 448 512">
        <path d="M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32H304c17.7 0 32-14.3 32-32V153.3C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96H256v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288H144c-53 0-96-43-96-96V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z" />
      </svg>
    ),
  },

  {
    name: "furniture",
    icon: (
      <svg viewBox="-20 -20 550 550" data-fill-hover>
        <path
          d="M82 98c-12 4-20 10-26 19-7 10-8 17-8 35v16h-9c-15 0-23 4-28 15l-3 6v174l2 5c5 9 15 16 25 16h5v14c0 19-1 18 20 18 18 0 17 1 23-18l3-14h340l3 14c6 19 5 18 24 18 20 0 19 1 19-18v-14h5c10 0 20-7 25-16l2-5v-87c0-85 0-87-2-91-3-7-7-11-13-14s-7-3-16-3h-9v-16c0-18-1-25-8-35-6-9-15-16-26-19-6-2-10-2-174-2-160 0-169 0-174 2m8 15c-7 1-13 5-17 10-7 7-8 12-9 30v15h9c9 0 10 0 16 3s10 7 13 14c2 4 2 7 2 27v23l6-3 12-6c6-2 9-2 134-2s128 0 134 2l12 6 6 3v-23c0-20 0-23 2-27 3-7 7-11 13-14s7-3 16-3h9v-15c-1-19-2-23-10-31-10-10 8-9-179-10l-169 1m-58 72-5 4c-2 3-2 3-2 87s0 84 2 87l5 4h448l5-4c2-3 3-4 3-85 0-89 0-87-5-91-3-2-4-2-27-2s-24 0-27 2c-5 3-5 4-5 61v52l-2 2-3 2H92l-2-2c-2-3-2-3-2-55 0-55 0-57-5-60-3-2-5-3-25-3l-26 1m98 56c-7 1-13 5-17 10-6 7-8 12-9 26v11h304v-11c-1-15-3-20-10-27-10-10 3-9-139-10l-129 1M56 392v8h9l1-6 3-8c0-2-1-2-6-2h-7v8m387-6 3 8 1 6h9v-16h-7c-5 0-6 0-6 2"
          fillRule="evenodd"
        />
      </svg>
    ),
  },

  {
    name: "shirt",
    icon: (
      <svg viewBox="-40 -40 600 600" data-fill-hover>
        <path
          fillRule="evenodd"
          d="m149 38-40 15c-5 4-108 96-108 98l-1 5c0 4 0 4 52 57l34 34v117l1 118 3 3 3 3h326l3-3 4-3V247l34-34 43-45c9-9 10-10 10-14 0-2 0-4-1-3l-1-1-108-96c-3-3-79-30-84-30s-9 4-10 11c-5 36-29 56-62 51-26-4-41-21-46-52 0-6-5-10-10-10l-42 14m2 21-31 12-37 33-48 43-10 9 31 31 30 31v-24c0-27 0-28 6-31 4-2 5-2 8-1l5 5c2 3 2 13 2 152v148h298V167l3-2c4-5 10-4 14 0l3 3v49l22-21 30-31 9-10-48-42-47-42-30-11-31-11-4 8c-7 19-22 36-40 44-15 7-34 8-49 4-25-7-46-27-53-51l-2-6-31 11M0 155c0 2 0 3 1 2v-4c-1-1-1 0-1 2"
        />
      </svg>
    ),
  },

  {
    name: "dogHand",
    icon: (
      <svg viewBox="0 0 512 512" data-fill-hover>
        <path
          fillRule="evenodd"
          d="M180 55c-19 3-36 20-44 43-4 13-5 23-5 38a83 83 0 0 0 29 63c18 14 39 13 56-3 18-16 28-45 25-74-1-14-4-24-10-36-11-22-30-34-51-31m140 0c-22 3-40 23-47 51-13 60 25 116 67 100 13-5 24-16 32-31 6-13 8-23 9-38 1-28-6-51-21-67a44 44 0 0 0-40-15M178 72c-5 2-13 8-16 12-9 11-14 30-14 48 0 33 17 59 38 59 16 1 29-13 36-36l1-23c0-15 0-19-2-25-3-11-7-19-14-26-9-9-19-12-29-9m138 1c-11 4-20 17-25 34-2 6-2 10-2 25l1 23c3 11 9 20 14 27 7 7 13 9 22 9 21 0 38-26 38-59 0-40-23-69-48-59M57 159c-21 5-34 27-33 59 2 34 18 64 41 74 3 2 6 2 14 2s9 0 15-3c16-8 25-26 25-52 0-25-8-48-23-64-11-13-26-19-39-16m384 0c-8 2-15 6-23 14a91 91 0 0 0-25 66c0 30 11 49 32 55h14c21-4 38-24 46-54 3-11 4-33 2-43-4-15-13-30-23-35l-17-4-6 1M55 178c-5 3-9 8-12 16-3 7-2 32 1 44 5 17 15 32 25 37 17 9 30-3 33-28 2-11 0-23-4-36-8-22-19-33-33-35-4-1-5-1-10 2m383 0c-7 4-14 12-19 22-21 41-5 90 24 75 10-5 18-16 24-34 3-8 3-11 4-22 1-20-3-33-11-39-4-3-5-3-11-4-5 0-7 0-11 2m-198 65c-14 3-31 10-41 18l-49 46c-47 44-50 47-55 61l-3 18c0 14 2 22 8 35 8 18 26 32 45 36l18 1c12-1 19-2 44-9a171 171 0 0 1 105 1c34 8 43 9 56 7a70 70 0 0 0 40-106c-4-5-87-84-96-91-8-6-19-11-31-15-7-2-11-2-22-3l-19 1m1 17c-12 3-23 8-32 15-7 5-88 82-91 86a51 51 0 0 0 29 79c11 3 25 1 59-7 45-12 60-12 111 1l33 7c23 2 47-16 52-40 2-8 1-21-2-28l-6-11c-3-5-82-80-91-87-7-5-20-11-27-14-9-2-27-2-35-1"
        />
      </svg>
    ),
  },

  {
    name: "makeup",
    icon: (
      <svg viewBox="-10 -10 550 550" data-fill-hover>
        <path
          d="M167 15c-17 2-36 11-52 21-10 7-29 27-34 35-6 10-6 11 5 22a20021 20021 0 0 1 65 68l7 8 5 17c3 14 74 258 88 304 2 7 2 8 5 9l12 1c9 0 18-2 25-7 9-5 9-3 1-40l-7-34 4-1 7-1a2591 2591 0 0 0 101-176c14-14 19-25 20-41s-3-27-12-36c-7-7-13-9-24-9-9 0-10 0-17 3a60 60 0 0 0-33 54c0 11 0 12-6 25l-27 78-22 64a13682 13682 0 0 1-45-210l-5-17 16-55 15-58c0-6-9-12-26-18-20-7-48-10-66-6m5 14c-4 0-4 0-3 2l6 38c0 6-6 10-11 7-3-1-3-2-7-23-3-18-4-19-6-19s-23 10-26 13l-2 2 13 23 12 26c0 6-7 9-11 6l-14-24-12-22-4 4-9 10-5 7 6 6c40 43 68 71 69 71l24-6 23-6 14-51 14-51c0-2-25-12-26-11l-7 45c-6 45-7 45-9 47-4 3-8 2-10-2a8961 8961 0 0 1 11-90v-3h-13l-17 1m23 136-21 5c-1 1 0 4 2 12l3 12 13-3 14-3 5 14-14 3-14 4 41 137 41 139 5 1c5 0 13-3 14-4 1-3-68-320-69-322l-20 5m181 5c-8 2-20 12-24 22-3 6-6 26-4 27l18 8 18 8 6-7c7-8 12-16 13-25 3-22-10-37-27-33m-36 71-4 9 10 5 11 5c1 1-2 10-5 14l-10-5c-6-2-10-4-11-3a5761 5761 0 0 0-42 137c2 0 76-132 81-145l5-11-15-6-16-7-4 7"
          fillRule="evenodd"
        />
      </svg>
    ),
  },

  {
    name: "save",
    icon: (
      <svg viewBox="0 0 512 512">
        <path
          fillRule="evenodd"
          d="M109 18c-14 3-28 15-34 27-6 13-6 1-6 214l1 194 2 6c5 17 19 30 36 35 9 3 24 2 33-1 8-2 11-5 59-44 24-20 46-36 48-37 5-2 12-2 17 0l49 39a1578 1578 0 0 0 58 43c30 10 63-9 70-41 2-10 2-384-1-394-4-20-19-36-39-41-8-3-285-3-293 0m9 31c-6 1-11 6-13 11l-3 6v191l1 192 2 4c3 6 9 9 16 10 5 0 8 0 10-2 2-1 24-17 47-37 24-20 47-37 50-39 18-11 40-11 56-1a1770 1770 0 0 1 97 77c5 3 12 2 18-1 4-2 6-4 8-8l3-5V65l-3-5c-2-4-4-6-7-8l-5-3-137-1-140 1"
        />
      </svg>
    ),
  },

  {
    name: "account",
    icon: (
      <svg width="20" height="20" viewBox="0 0 20 20">
        <path
          d="M9.99999 1.66667C5.39999 1.66667 1.66666 5.40001 1.66666 10C1.66666 14.6 5.39999 18.3333 9.99999 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.40001 14.6 1.66667 9.99999 1.66667ZM5.89166 15.2333C6.24999 14.4833 8.43332 13.75 9.99999 13.75C11.5667 13.75 13.7583 14.4833 14.1083 15.2333C12.975 16.1333 11.55 16.6667 9.99999 16.6667C8.44999 16.6667 7.02499 16.1333 5.89166 15.2333ZM15.3 14.025C14.1083 12.575 11.2167 12.0833 9.99999 12.0833C8.78332 12.0833 5.89166 12.575 4.69999 14.025C3.84999 12.9083 3.33332 11.5167 3.33332 10C3.33332 6.32501 6.32499 3.33334 9.99999 3.33334C13.675 3.33334 16.6667 6.32501 16.6667 10C16.6667 11.5167 16.15 12.9083 15.3 14.025Z"
          fill="#5F6368"
        />
        <path
          d="M10 5C8.38334 5 7.08334 6.3 7.08334 7.91667C7.08334 9.53333 8.38334 10.8333 10 10.8333C11.6167 10.8333 12.9167 9.53333 12.9167 7.91667C12.9167 6.3 11.6167 5 10 5ZM10 9.16667C9.30834 9.16667 8.75001 8.60833 8.75001 7.91667C8.75001 7.225 9.30834 6.66667 10 6.66667C10.6917 6.66667 11.25 7.225 11.25 7.91667C11.25 8.60833 10.6917 9.16667 10 9.16667Z"
          fill="#5F6368"
        />
      </svg>
    ),
  },

  {
    name: "arrowRightShort",
    icon: (
      <svg width="16" fill="currentColor" viewBox="0 0 16 16">
        <path
          fillRule="evenodd"
          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"
        />
      </svg>
    ),
  },

  {
    name: "arrowLeftShort",
    icon: (
      <svg width="16" fill="currentColor" viewBox="0 0 16 16">
        <path
          fillRule="evenodd"
          d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
        />
      </svg>
    ),
  },

  {
    name: "exclamation",
    icon: (
      <svg viewBox="0 0 64 512">
        <path d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" />
      </svg>
    ),
  },

  {
    name: "questionMark",
    icon: (
      <svg width="16" fill="currentColor" viewBox="0 0 16 16">
        <path
          fillRule="evenodd"
          d="M4.475 5.458c-.284 0-.514-.237-.47-.517C4.28 3.24 5.576 2 7.825 2c2.25 0 3.767 1.36 3.767 3.215 0 1.344-.665 2.288-1.79 2.973-1.1.659-1.414 1.118-1.414 2.01v.03a.5.5 0 0 1-.5.5h-.77a.5.5 0 0 1-.5-.495l-.003-.2c-.043-1.221.477-2.001 1.645-2.712 1.03-.632 1.397-1.135 1.397-2.028 0-.979-.758-1.698-1.926-1.698-1.009 0-1.71.529-1.938 1.402-.066.254-.278.461-.54.461h-.777ZM7.496 14c.622 0 1.095-.474 1.095-1.09 0-.618-.473-1.092-1.095-1.092-.606 0-1.087.474-1.087 1.091S6.89 14 7.496 14"
        />
      </svg>
    ),
  },
];
